import {svgIconWrapper} from '../svg-icon-wrapper';

import KixieRegular from './kixie-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <KixieRegular {...props} />;
}

SvgComponent.iconName = 'kixieRegular';

export const KixieRegularIcon = svgIconWrapper(SvgComponent);
